import type { GetCustomerContractsOverviewPageResponse } from '@vy/api-definition';
import { GetCustomerContractsOverviewPageResponseSchema } from '@vy/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';
import { queryKeys } from '../../services/query-key/query-keys';

export function useGetCustomerContractsOverviewPage(
  customerId: string,
  options?: CustomUseQueryOptions<GetCustomerContractsOverviewPageResponse>,
) {
  return useQuery({
    queryKey: queryKeys.customerContractsOverviewPage(customerId),
    ...options,
    queryFn: async () => {
      const api = getPrivateApi();
      const getCustomerContractsOverviewPageResponse = await api.getCustomerContractsOverviewPage({
        customerId,
      });

      return GetCustomerContractsOverviewPageResponseSchema.parse(getCustomerContractsOverviewPageResponse);
    },
  });
}
